import Image from "next/image";

import { Link } from "@/i18n/navigation";
import { cn } from "@/lib/utils";

import type { MarketingLogoProps } from "./MarketingLogo.types";

export const MarketingLogo = ({
  className,
  imageClassName,
  priority = false,
}: MarketingLogoProps) => (
  <Link href="/" className={cn("inline-flex shrink-0 items-center", className)}>
    <Image
      src="/rivetai-logo.png"
      alt="RivetAI"
      width={120}
      height={60}
      priority={priority}
      className={cn("h-9 w-auto", imageClassName)}
    />
  </Link>
);
